module.exports = __webpack_public_path__ + "img/banner-3-en-mobile.864f4795.png";